export default "__VITE_ASSET__DC3mwb$U__"